import { ofType } from 'redux-observable';
import { catchError, map, switchMap, withLatestFrom } from 'rxjs/operators';
import { EMPTY, from, of, concat, defer } from 'rxjs';
import { httpMethods, request } from '../../../../../services/http-service';
import { RETRIEVE_SPESA } from '../../data.const';
import { setCurrentSpesaAction, setLoaders } from '../../data.action';

const retrieveSpesaEpic = (action$: any, state$: any) =>
  action$.pipe(
    ofType(RETRIEVE_SPESA),
    map(({ payload }: any) => payload),
    // tap(p => console.log(`[epic ${RETRIEVE_SPESA}]`, p)),
    withLatestFrom(state$),
    switchMap(([id, _state]) => {
      return concat(
        of(setLoaders({ incaricoLoader: true })),
        defer(() =>
          from(request({ path: `spesa/${id}`, method: httpMethods.GET })).pipe(
            map((p: any) => {
              if (p?.status > 299) {
                throw new Error('Server error');
              }
              return p?.result;
            }),
            // tap(p => console.log(`[epic ${RETRIEVE_SPESA}]`, p)),
            // switchMap(() => EMPTY),
            switchMap((p) => of(setCurrentSpesaAction(p))),
            catchError((err) => {
              console.error(`[epic ${RETRIEVE_SPESA}] error`, err);
              return EMPTY;
            })
          )
        ),
        of(setLoaders({ incaricoLoader: false }))
      );
    })
  );

export default retrieveSpesaEpic;
